module.exports = __webpack_public_path__ + "static/media/post12.437c0e23.PNG";